import { useTranslation } from 'react-i18next';
import type { CaptionTokens } from '@/lib/campaigns/getSubmissionFeedback';

/** Names the campaign tags behind a caption rejection and how they are matched. */
export function CaptionTokensNote({ captionTokens }: { captionTokens: CaptionTokens }) {
  const { t } = useTranslation();
  return (
    <div className="mt-1 space-y-0.5">
      <p>{t(`campaign.submissions.captionTokens.${captionTokens.source}`, { tokens: captionTokens.tokens.join(', ') })}</p>
      <p className="text-xs text-muted-foreground">{t('campaign.submissions.captionTokens.hint')}</p>
    </div>
  );
}
